import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'
import _ from 'lodash'


export const state = {
  changelogs: []
}

export const mutations = {
  fetchChangelogs(state, changelogs) {
    state.changelogs = changelogs
  },
}

export const actions = {
  async fetchChangelogs({ commit }, options) {

    let request = {
      entityId: options.entityId,
      entityType: options.entityType,
      userId: options.userId,
      searchTerm: options.searchTerm,
    }

    if (options.companyId) {
      request.companyId = options.companyId
    }

    if (options.startDate) {
      request.startDate = options.startDate
    }

    if (options.endDate) {
      request.endDate = options.endDate
    }

    if (options.dateRange) {
      request.dateRange = options.dateRange
    }

    await post(Endpoints.getUrl('changelog.list'), request)
      .then(changelogs => {
        commit('fetchChangelogs', changelogs.data.items)
      }).catch((err) => console.log(err))
  },
}

export const getters = {
  changelogs: state => {

    return state.changelogs
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
